<template>
  <div class="page">
    <div class="background">
      <div class="lt" :class="(screen === 2)? 'second':''"></div>
      <div class="rt"></div>
      <div class="rm"></div>
      <div class="rb"></div>
      <div class="lb"></div>
      <div class="lm"></div>
    </div>
    <div class="screen">
      <top-block></top-block>
      <transition name="slide-bot">
        <div class="screen" v-if="screen === 1">
          <div class="absolute-center">
            <div class="intro">
              <h1>Путь к успеху</h1>
              <p class="subHeader">
                Ответственное собеседование, путешествие мечты или, например, свадьба лучшей подруги – любое
                из этих событий может внезапно пойти не так, как вы запланировали. Узнайте о том, с какими
                неожиданными
                проблемами
                вы можете столкнуться, и решите,
                как поступить в этих ситуациях правильно.</p>
              <div class="arrow-down" @click="screen = 2"></div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="slide-top">
        <div class="screen" v-if="screen === 2">
          <div class="absolute-center">

            <div class="screen-2">
              <div class="arrow-top" @click="screen = 1"></div>
              <p>Выберите свою героиню</p>
              <div class="container">
                <div class="arrow-left" @click="prevPerson()"></div>
                <div class="persons">

                  <transition :name="transition">
                    <div class="person" v-if="person === 1" @click="linkTo('svetlana')">
                      <div class="person-image person-1"></div>
                      <div class="person-text person-1">Погуляйте <br>
                        на свадьбе
                      </div>
                    </div>
                  </transition>
                  <transition :name="transition">
                    <div class="person" v-if="person === 2" @click="linkTo('elena')">
                      <div class="person-image person-2"></div>
                      <div class="person-text person-2">Пройдите
                        <br>
                        собеседование
                      </div>
                    </div>
                  </transition>
                  <transition :name="transition">
                    <div class="person" v-if="person === 3" @click="linkTo('maria')">
                      <div class="person-image person-3"></div>
                      <div class="person-text person-3">Отправьтесь
                        <br>
                        в путешествие
                      </div>
                    </div>
                  </transition>

                </div>
                <div class="arrow-right" @click="nextPerson()"></div>
              </div>
              <div class="dots">
                <div class="dot" :class="(person ===1)?'active':''" @click="showPerson(1)"></div>
                <div class="dot" :class="(person ===2)?'active':''" @click="showPerson(2)"></div>
                <div class="dot" :class="(person ===3)?'active':''" @click="showPerson(3)"></div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <bot-block></bot-block>
    </div>
  </div>
</template>

<script>
    import TopBlock from '@/components/TopBlock.vue';
    import BotBlock from '@/components/BotBlock.vue';

    export default {
        name: "IndexMobile",
        components: {
            TopBlock,
            BotBlock,
        },
        data() {
            return {
                screen: 1,
                person: 1,
                transition: 'slide-left'
            }
        },
        methods: {
             linkTo(name){
            this.$router.push(name)
        },
            nextPerson() {
                this.transition = 'slide-left';
                this.person = (this.person === 3) ? 1 : this.person + 1;
            },
            prevPerson() {
                this.transition = 'slide-right';
                this.person = (this.person === 1) ? 3 : this.person - 1;
            },
            showPerson(id) {
                this.transition = (this.person < id) ? 'slide-left' : 'slide-right';
                this.person = id;
            }
        }
    }
</script>

<style scoped lang="scss">
  .page {
    position: relative;
    height: 100vh;
    min-height: 70vmax;
  }

  .background {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    .lt {
      position: absolute;
      left: 0;
      top: 0;
      width: 39vmin;
      max-width: 246px;
      max-height: 360px;
      height: 57vmin;
      background-image: url("../../assets/img/index/lt-mobile.png");
      background-size: contain;
      background-repeat: no-repeat;
      background-position: top left;
      /*transition: all 500ms;*/

      &.second {
        background-image: url("../../assets/img/index/lt-mobile-2.png");
        max-width: 207px;
        width: 32vmin;

      }
    }
    .rt {
      position: absolute;
      right: 0;
      top: 0;
      width: 43vmin;
      max-width: 274px;
      max-height: 234px;
      height: 37vmin;
      background-image: url("../../assets/img/index/rt-mobile.png");
      background-size: contain;
      background-repeat: no-repeat;
      background-position: top right;

    }
    .rm {
      position: absolute;
      right: 0;
      top: 50%;
      background-image: url("../../assets/img/index/rm-mobile.png");
      max-width: 63px;
      max-height: 219px;
      transform: translateY(-71%);
      width: 10vmin;
      height: 34vmin;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: top right;

    }
    .rb {
      position: absolute;
      right: 0;
      bottom: 0;
      background-image: url("../../assets/img/index/rb-mobile.png");
      max-width: 229px;
      max-height: 302px;
      width: 36vmin;
      height: 47vmin;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: right bottom;
    }
    .lb {
      position: absolute;
      left: 0;
      bottom: 0;
      background-image: url("../../assets/img/index/lb-mobile.png");
      max-width: 380px;
      max-height: 230px;
      width: 59vmin;
      height: 37vmin;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: left bottom;
    }
    .lm {
      position: absolute;
      left: 0;
      bottom: 26%;
      background-image: url("../../assets/img/index/lm-mobile.png");
      max-width: 292px;
      max-height: 223px;
      width: 45vmin;
      height: 39vmin;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: bottom left
    }
  }

  .absolute-center {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .screen {
    width: 100%;
    height: 100%;
    z-index: 3;
    overflow: hidden;
  }

  h1 {
    font-family: 'Playfair Display', serif;
    color: #323232;
    font-size: 32px; /* Приближение из-за подстановки шрифтов */
    font-weight: 700;
    font-style: italic;
    line-height: 20px; /* Приближение из-за подстановки шрифтов */
    text-align: center;
    margin-top: 31px;
  }

  .subHeader {
    font-family: 'Roboto', sans-serif;
    color: #323232;
    font-size: 16px; /* Приближение из-за подстановки шрифтов */
    font-weight: 400;
    text-align: center;
  }

  .intro {
    width: 77vmin;
  }

  .arrow-down {
    margin: 0 auto;
    height: 11px;
    width: 15px;
    background-size: contain;
    background-repeat: no-repeat;
    cursor: pointer;
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='30.5' height='20.5'%3E%3Cpath fill-rule='evenodd' stroke='%23000' stroke-width='3' stroke-linecap='round' d='M4.146 4.854l.708-.708 10 10-.708.708-10-10zM24.666 4.624l.71.71-10.042 10.042-.71-.71L24.666 4.624z'/%3E%3C/svg%3E");
  }

  .arrow-top {
    margin: 0 auto;
    height: 11px;
    width: 15px;
    margin-bottom: 28px;
    background-size: contain;
    background-repeat: no-repeat;
    cursor: pointer;
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='30.5' height='20.5'%3E%3Cpath fill-rule='evenodd' stroke='%23000' stroke-width='3' stroke-linecap='round' d='M4.146 4.854l.708-.708 10 10-.708.708-10-10zM24.666 4.624l.71.71-10.042 10.042-.71-.71L24.666 4.624z'/%3E%3C/svg%3E");
    transform: rotate(180deg);
  }

  .arrow-left {
    height: 15px;
    width: 11px;
    background-size: contain;
    background-repeat: no-repeat;
    cursor: pointer;
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='19.5' height='29.5'%3E%3Cpath fill-rule='evenodd' stroke='%23000' stroke-width='3' stroke-linecap='round' d='M13.724 3.628l.68.691-9.617 9.767-.68-.691 9.617-9.767zM13.945 23.67l-.683.693-9.657-9.808.682-.693 9.658 9.808z'/%3E%3C/svg%3E");
    // transform: rotate(180deg);
  }

  .arrow-right {
    height: 15px;
    width: 11px;
    background-size: contain;
    background-repeat: no-repeat;
    cursor: pointer;
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='19.5' height='29.5'%3E%3Cpath fill-rule='evenodd' stroke='%23000' stroke-width='3' stroke-linecap='round' d='M13.724 3.628l.68.691-9.617 9.767-.68-.691 9.617-9.767zM13.945 23.67l-.683.693-9.657-9.808.682-.693 9.658 9.808z'/%3E%3C/svg%3E");
    transform: rotate(180deg);
  }

  .screen-2 {
    width: 81vw;
    max-width: 500px;

  }

  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  p {
    font-family: 'Roboto', sans-serif;
    color: #323232;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
  }

  .person {
    .person-text {
      font-family: 'Playfair Display', serif;
      color: #323232;
      font-size: 25px;
      font-style: italic;
      line-height: 23px;
      text-align: left;
      background-repeat: no-repeat;
      background-size: auto 100%;
      padding-bottom: 17px;
      padding-top: 12px;
      display: block;
      margin: auto;

      &.person-1 {
        background-image: url("../../assets/img/index/1.png");
        width: 120px;
      }
      &.person-2 {
        background-image: url("../../assets/img/index/2.png");
        width: 140px;
      }
      &.person-3 {
        background-image: url("../../assets/img/index/3.png");
        width: 180px;
      }

    }
    .person-image {
      background-repeat: no-repeat;
      background-size: contain;
      margin: 0 auto;

      &.person-1 {
        background-image: url("../../assets/img/index/person1.png");
        width: 42vw;
        height: 62vw;
      }
      &.person-2 {
        background-image: url("../../assets/img/index/person2.png");
        width: 42vw;
        height: 62vw;
      }
      &.person-3 {
        background-image: url("../../assets/img/index/person3.png");
        width: 54vw;
        height: 62vw;
      }

    }
  }

  .dots {
    margin: 20px auto;
    width: 40px;
    display: flex;
    justify-content: space-between;
  }

  .dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    border: #f5f5f5 1px solid;
    box-shadow: 0 0 2px #323232;
    display: inline-flex;

    &.active {
      background-color: #cba76c;

    }
  }
</style>


// WEBPACK FOOTER //
// src/components/IndexPage/IndexMobile.vue